<template>
  <HeaderStatus
    :agent-name="authStore.agentName"
    :conversation-id="authStore.conversationId || undefined"
    :language="authStore.language || undefined"
    :genesys-status="messageStore.connectionStatus.genesys"
    :backend-status="messageStore.connectionStatus.backend"
    :initialization-failed="initializationFailed"
  />
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth';
import { useMessageStore } from '@/stores/messages';
import HeaderStatus from '@/components/header/HeaderStatus.vue';

// Props
interface Props {
  initializationFailed?: boolean;
}

withDefaults(defineProps<Props>(), {
  initializationFailed: false,
});

// Stores
const authStore = useAuthStore();
const messageStore = useMessageStore();
</script>
